import navigation from "app/navigation/catalog";

export const getAvailableViews = () => {
  const views = [];
  const seen = new Set();
  const traverse = (items, parentKey, level = 0) => {
    items.forEach((item) => {
      const key = item.availablePermissionKey || item.permissionKey;
      if (key && !item.public && !seen.has(key)) {
        seen.add(key);
        views.push({ key, name: item.name, parentKey, level });
      }
      if (item.collapse) traverse(item.collapse, key || parentKey, level + 1);
    });
  };
  traverse(navigation);
  return views;
};
